// Invisible mode is configured by the site key, not by a Turnstile size value.
export const turnstileSize = (size: "normal" | "compact" | "invisible") =>
  size === "invisible" ? "normal" : size;